import React, { useEffect, useRef } from 'react';
import { AMapInstance, AMapMarker } from '../types';

interface MapContainerProps {
  map: AMapInstance | null;
  markers: (AMapMarker | undefined)[];
  isMapInitialized: boolean;
  loading?: boolean;
  error?: string | null;
}

const MapContainer: React.FC<MapContainerProps> = ({
  map,
  markers,
  isMapInitialized,
  loading = false,
  error = null
}) => {
  const mapContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (mapContainerRef.current && map) {
      const container = map.getContainer();
      if (container !== mapContainerRef.current) {
        map.setContainer(mapContainerRef.current);
      }
    }
  }, [map]);

  return (
    <div className="map-panel">
      <div
        ref={mapContainerRef}
        id="map"
        className="map-container"
        style={{ position: 'relative' }}
      >
        {loading && (
          <div className="map-loading" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            zIndex: 1000
          }}>
            <div className="spinner large"></div>
            <div className="loading-text">正在初始化地图...</div>
          </div>
        )}

        {error && !loading && (
          <div className="map-error" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            zIndex: 1000
          }}>
            <div className="error-icon">⚠️</div>
            <div className="error-text">
              <div className="error-title">地图加载失败</div>
              <div className="error-message">{error}</div>
            </div>
          </div>
        )}

        {!isMapInitialized && !loading && !error && !map && (
          <div className="map-placeholder" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f5f5f5',
            zIndex: 1000
          }}>
            <div className="placeholder-icon">🗺️</div>
            <div className="placeholder-text">
              <div className="placeholder-title">请先配置API密钥</div>
              <div className="placeholder-description">
                需要配置高德地图API Key和安全密钥才能使用地图功能
              </div>
            </div>
          </div>
        )}
      </div>

      {markers && markers.length > 0 && (
        <div className="map-info">
          <div className="marker-count">
            已显示 {markers.filter(m => m !== undefined).length} 个地址标记
          </div>
        </div>
      )}
    </div>
  );
};

export default MapContainer;
